module.exports = __webpack_public_path__ + "img/icon_gongpin.cc6f4fe0.png";